
export const BASE_URL_WIFI = "https://api.wifiattendance.com/";  //live


const MAIN_BASE_URL= "https://zamzam.crm-api.wifiattendance.com:3016";//live 
// const MAIN_BASE_URL= "https://tunnel.cloudvolte.com";//tunnel 
// const MAIN_BASE_URL= "https://staging.crm-api.wifiattendance.com:3017";//staging 
// const MAIN_BASE_URL= "http://localhost:3016";//local 

const BASE_URL = MAIN_BASE_URL;//live 
const SOCKET_URL = MAIN_BASE_URL;//live 
const BASE_URL_TRACKING ="https://api.vehicletracking.qa:3000";//live 
// const BASE_URL_TRACKING ="http://192.168.1.36:3002";//Demo 
const Dot_Net_BASE_URL ="https://api.wifiattendance.com";//.net dev 
// const Dot_Net_BASE_URL ="http://3.137.74.85:8080";//.net dev 
// const BASE_URL = "http://192.168.1.38:3016";//svinod
// const BASE_URL = "http://192.168.1.44:3016";//amer 


const ApiConfig = {
    BASE_URL:BASE_URL,
    BASE_URL_WIFI:BASE_URL_WIFI,
    SOCKET_URL:SOCKET_URL,
    x_api_key:'kPKPH5lmXbgi6XL2+ptg7Q==',
    BASE_URL_TRACKING:BASE_URL_TRACKING,
    SEND_OTP: BASE_URL + "/api/user/sendOtp",
    LOGIN_WITH_OTP: BASE_URL + "/api/user/loginWithOtp",
    WIFI_LOGIN: BASE_URL_WIFI + "api/authentication/authenticate",
    GET_REGISTERED_USER_AGENT: BASE_URL + "/api/mark_users",
    UPDATE_CONTACT_USER_WIF : BASE_URL + "/api/updateUser/",
    WIFI_USER: BASE_URL + "api/authentication/",
    ORDER_CREATE: BASE_URL + "/api/order/v2/create",
    ORDER_CREATE_CALOLATE: BASE_URL + "/api/cart/calculate-delivery-fee",
    GET_DELIVERY_FEE: BASE_URL + "/api/cart/calculate-delivery-fee",
    CREATE_USER: BASE_URL + "/api/user/createUser",
  OrderList: BASE_URL + "/api/v1/order",
 
  CHANGE_STAUS_ORDER: BASE_URL + "/api/v1/order/status",
//   Ashmer

    // My Orders 
    ORDER_LIST: BASE_URL + "/api/order/get",
    MAKE_CALL: BASE_URL + "/api/make-call-agent",
    GET_PROFILE: BASE_URL + "/api/user/my-profile",
    UPDATE_PROFILE: BASE_URL + "/api/user/update-profile",
    DRIVER_RATING: BASE_URL + "/api/order/add-driver-rating",
    ORDER_RATING: BASE_URL + "/api/order/add-order-rating",
    ORDER_REPEAT: BASE_URL + "/api/order/repeat-order",
    ORDER_STATUS: BASE_URL + "/api/order/order-status",
    GET_MENU: BASE_URL + "/api/menu/v2",
    GET_MENU2: BASE_URL + "/api/menu/",

    GET_IMAGES: BASE_URL + "/api/menu/images",
    GET_NOTIFICATIONS: BASE_URL + "/api/notification/notify",
    GET_MENU_CATEGORY: BASE_URL + "/api/menu/category",
    GET_RESTAURANT: BASE_URL + "/api/restaurant",
    GET_RESTAURANT_LIST: BASE_URL + "/api/restaurant/all",
    GET_RESTAURANT_Landmark: BASE_URL_TRACKING + "/PointOfInterest/search-landmark-bycode",
    PATCH_RESTAURANT_SELECT: BASE_URL + "/api/restaurant/select",
    RESTAURANT_DISPATCH_SETTINGS: BASE_URL + "/api/restaurant/restaurant-config",
    RESTAURANT_DISPATCH_CALCUATE_: BASE_URL + "/api/restaurant/calculate-delivery-fee",
    RESTAURANT_DISPATCH_CALCUATE_22: BASE_URL + "/api/restaurant/here-is-my-change",
    WISHLIST: BASE_URL + "/api/menu/wishlist",
    Add_TO_CART: BASE_URL + "/api/cart/add-cart-item",
    CART_LIST: BASE_URL + "/api/cart/list-cart",
    LIST_DISCOUNT: BASE_URL + "/api/cart/discounts",
    UPDATE_CART: BASE_URL + "/api/cart/update-quantity",
    REMOVE_CART_ITEM: BASE_URL + "/api/cart/remove-cart-item",
    CREATE_OR_GET_UPDATE_ADDRESS: BASE_URL + "/api/user/address",
    DELETE_USER: BASE_URL + "/api/user/deleteUser",
    ConvertLatLongToAddress:  'https://nominatim.openstreetmap.org/reverse?format=jsonv2&', //get for list, post for add
    SearchAddress: 'https://nominatim.openstreetmap.org/search?format=json&q=', //get for list, post for add
    // PAYMENT_CHEKOUT:BASE_URL + '/api/paymentRoute/checkout',
    // PAYMENT_VERIFICATION: BASE_URL + '/api/paymentRoute/paymentverification',
    // PAYMENT_INITIATE:Dot_Net_BASE_URL + '/api/transaction/initiatepayment',
    PAYMENT_INITIATE:BASE_URL + '/api/restaurant/',
    // PAYMENT_VERIFY: Dot_Net_BASE_URL + '/api/transaction/verifypayment',
    PAYMENT_VERIFY: BASE_URL + '/api/restaurant/',
    GET_RESTAURANT_BANNERS: BASE_URL+'/api/banners?restaurant_id=',

    // New v2 online-payment flow: ORDER_CREATE -> initiate-payment -> gateway window -> confirm-payment
    // Append `${restaurant_id}/initiate-payment` at the call site.
    PAYMENT_INITIATE_V2: BASE_URL + '/api/restaurant/v2/',
    CONFIRM_PAYMENT_V2: BASE_URL + '/api/order/v2/confirm-payment',

    // Contact us apI 
    CONTACT_US :BASE_URL+'/api/create_email_inquiry/',
}

export default ApiConfig